<template>
  <div>{{ displayType }}</div>
</template>

<script>
import {dealTypes} from "@/utilities/invest_deal_types";

export default {
  name: "EventType",
  props: {
    deal_type: {
      type: Number,
      required: true
    }
  },
  computed: {
    displayType() {
      switch (this.deal_type) {
        case dealTypes.TYPE_BUY:
          return 'Покупка'
        case dealTypes.TYPE_SELL:
          return 'Продажа'
        case dealTypes.TYPE_INCOME_DIVIDEND:
          return 'Дивиденд'
        case dealTypes.TYPE_INCOME_COUPON:
          return 'Купон'
        case dealTypes.TYPE_INCOME_AMORTIZATION:
          return 'Амортизация'
        case dealTypes.TYPE_DEPOSITING:
          return 'Внесение'
        case dealTypes.TYPE_WITHDRAWAL:
          return 'Вывод'
        case dealTypes.TYPE_EXPENSE_TAX:
          return 'Налог'
        case dealTypes.TYPE_EXPENSE_COMMISSION:
          return 'Комиссия'
        default:
          return ''
      }
    }
  }
}
</script>